var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportSupporters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#2E3133",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3328 46.0003C20.759 46.0003 18.5601 45.0815 16.7358 43.244C14.9116 41.4065 13.9995 39.1607 13.9995 36.5065C13.9995 34.2315 14.6641 32.2044 15.9934 30.4253C17.3227 28.6461 19.0621 27.5086 21.2116 27.0128C21.9186 24.3294 23.3328 22.1565 25.454 20.494C27.5752 18.8315 29.9792 18.0003 32.6661 18.0003C35.9752 18.0003 38.7823 19.1888 41.0873 21.5659C43.3924 23.943 44.5449 26.8378 44.5449 30.2503C46.4964 30.4836 48.1156 31.3513 49.4025 32.8534C50.6894 34.3555 51.3328 36.1128 51.3328 38.1253C51.3328 40.3128 50.5904 42.1721 49.1055 43.7034C47.6207 45.2346 45.8176 46.0003 43.6964 46.0003H34.3631C33.4298 46.0003 32.6308 45.6576 31.9661 44.9721C31.3015 44.2867 30.9691 43.4628 30.9691 42.5003V33.4878L28.254 36.2003L25.8782 33.7503L32.6661 26.7503L39.454 33.7503L37.0782 36.2003L34.3631 33.4878V42.5003H43.6964C44.8843 42.5003 45.8883 42.0774 46.7085 41.2315C47.5287 40.3857 47.9388 39.3503 47.9388 38.1253C47.9388 36.9003 47.5287 35.8649 46.7085 35.019C45.8883 34.1732 44.8843 33.7503 43.6964 33.7503H41.151V30.2503C41.151 27.8294 40.3237 25.7659 38.6691 24.0596C37.0146 22.3534 35.0136 21.5003 32.6661 21.5003C30.3186 21.5003 28.3176 22.3534 26.6631 24.0596C25.0085 25.7659 24.1813 27.8294 24.1813 30.2503H23.3328C21.6924 30.2503 20.2924 30.8482 19.1328 32.044C17.9732 33.2399 17.3934 34.6836 17.3934 36.3753C17.3934 38.0669 17.9732 39.5107 19.1328 40.7065C20.2924 41.9024 21.6924 42.5003 23.3328 42.5003H27.5752V46.0003H23.3328Z",
    fill: "#90A4AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportSupporters);
export default __webpack_public_path__ + "static/media/ImportSupporters.3113eca9398e18847f9da23fa06c65ee.svg";
export { ForwardRef as ReactComponent };